/**
 * Navegação vertical da tira de miniaturas (desktop).
 *
 * Contexto: a tira é uma coluna com max-height e overflow-y. O tema exibia
 * apenas um "⌄" desenhado via ::after, que tem pointer-events: none e portanto
 * nunca foi clicável. Os botões nativos do SliderComponent ficam display:none
 * nesse layout e, mesmo visíveis, não funcionariam: a matemática deles é
 * horizontal (offsetLeft/scrollLeft) e numa coluna o passo dá zero.
 *
 * Este script injeta botões reais e faz a rolagem vertical de verdade.
 */
(function () {
  const SELECTOR = '.thumbnail-slider';
  const LIST = '.thumbnail-list';

  function itemStep(list) {
    const items = list.querySelectorAll('.thumbnail-list__item');
    if (items.length > 1) {
      const step = items[1].offsetTop - items[0].offsetTop;
      if (step > 0) return step;
    }
    return items.length ? items[0].offsetHeight || 80 : 80;
  }

  function makeButton(direction) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `thumbnail-vertical-nav thumbnail-vertical-nav--${direction}`;
    button.innerHTML = direction === 'up' ? '&#8593;' : '&#8595;';
    button.setAttribute(
      'aria-label',
      direction === 'up' ? 'Ver miniaturas anteriores' : 'Ver mais miniaturas'
    );
    return button;
  }

  function setup(slider) {
    if (slider.dataset.verticalNavReady === 'true') return;

    const list = slider.querySelector(LIST);
    if (!list) return;

    // Só faz sentido quando a lista está realmente em coluna
    if (getComputedStyle(list).flexDirection !== 'column') return;

    slider.dataset.verticalNavReady = 'true';
    slider.classList.add('has-vertical-nav');

    const up = makeButton('up');
    const down = makeButton('down');
    slider.appendChild(up);
    slider.appendChild(down);

    // A folha de estilo aplica `scroll-behavior: smooth !important` nesta
    // lista e, neste layout, o navegador descarta a animacao suave: tanto
    // `scrollTop = x` quanto `scrollBy({behavior:'smooth'})` nao saem do lugar.
    // Como o !important tambem impede sobrescrever inline, animamos na mao com
    // requestAnimationFrame usando `behavior: 'instant'` a cada quadro.
    const setScrollTop = (value) => {
      try {
        list.scrollTo({ top: value, behavior: 'instant' });
      } catch (e) {
        list.scrollTop = value;
      }
    };

    let animationId = null;

    const animateTo = (target, duration = 300) => {
      const max = list.scrollHeight - list.clientHeight;
      const to = Math.max(0, Math.min(target, max));
      const start = list.scrollTop;
      const delta = to - start;

      if (animationId) cancelAnimationFrame(animationId);
      if (Math.abs(delta) < 1) return;

      // Se o usuario pediu menos animacao, ir direto
      const reduzirMovimento =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduzirMovimento || typeof requestAnimationFrame !== 'function') {
        setScrollTop(to);
        refresh();
        return;
      }

      // Rede de seguranca: em aba oculta ou renderizacao suspensa o
      // requestAnimationFrame nunca dispara. Se nenhum quadro rodar, o clique
      // ainda tem que mover a tira.
      let primeiroQuadroRodou = false;
      setTimeout(() => {
        if (!primeiroQuadroRodou) {
          if (animationId) cancelAnimationFrame(animationId);
          animationId = null;
          setScrollTop(to);
          refresh();
        }
      }, 120);

      const startedAt = performance.now();

      const step = (now) => {
        primeiroQuadroRodou = true;
        const progress = Math.min(1, (now - startedAt) / duration);
        // easeInOutQuad
        const eased =
          progress < 0.5
            ? 2 * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 2) / 2;

        setScrollTop(start + delta * eased);

        if (progress < 1) {
          animationId = requestAnimationFrame(step);
        } else {
          animationId = null;
          refresh();
        }
      };

      animationId = requestAnimationFrame(step);
    };

    const scrollBy = (dir) => {
      // 3 miniaturas por clique, sem ultrapassar os limites
      animateTo(list.scrollTop + itemStep(list) * 3 * dir);
    };

    up.addEventListener('click', (e) => {
      e.preventDefault();
      scrollBy(-1);
    });

    down.addEventListener('click', (e) => {
      e.preventDefault();
      scrollBy(1);
    });

    const refresh = () => {
      const overflow = list.scrollHeight - list.clientHeight;

      // Sem transbordo: nenhum botão faz sentido
      if (overflow <= 1) {
        up.hidden = true;
        down.hidden = true;
        slider.classList.add('at-end');
        return;
      }

      const atTop = list.scrollTop <= 1;
      const atEnd = list.scrollTop >= overflow - 1;

      up.hidden = atTop;
      down.hidden = atEnd;
      slider.classList.toggle('at-end', atEnd);
    };

    list.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);

    // A lista pode ser re-renderizada ao trocar de variante
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(refresh).observe(list, { childList: true });
    }

    refresh();
    // Imagens ainda carregando mudam a altura total
    setTimeout(refresh, 600);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
